__webpack_require__.p = "https://static.s-shot.ru/_next/";